import React, { useEffect, useState } from 'react';
import { Alert, Box, Portal, Slide, useTheme } from '@mui/material';

export default function NewVersionBanner() {
  const theme = useTheme();
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    if (!('serviceWorker' in navigator) || !navigator.storage?.estimate) return;

    const checkStorage = async () => {
      if (document.visibilityState !== 'visible') return;
      if (!navigator.serviceWorker.controller) return;
      try {
        const { usage, quota } = await navigator.storage.estimate();
        navigator.serviceWorker.controller.postMessage({
          type: 'CHECK_STORAGE',
          usage,
          quota,
        });
      } catch {
        navigator.serviceWorker.controller.postMessage({
          type: 'CHECK_STORAGE',
        });
      }
    };

    // Run once immediately on mount so storage pressure is checked at app open,
    // not just after the first 5-minute tick.
    checkStorage();
    const id = setInterval(checkStorage, 5 * 60 * 1000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    navigator.serviceWorker.getRegistration().then((registration) => {
      if (!registration) return;

      const activate = (worker) => {
        if (!worker) return;
        worker.postMessage({ type: 'SKIP_WAITING' });
        setUpdateAvailable(true);
        setTimeout(() => setUpdateAvailable(false), 10000);
      };

      if (registration.waiting) {
        activate(registration.waiting);
      }

      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (!newWorker) return;

        newWorker.addEventListener('statechange', () => {
          if (
            newWorker.state === 'installed' &&
            navigator.serviceWorker.controller
          ) {
            activate(registration.waiting || newWorker);
          }
        });
      });
    });
  }, []);

  return (
    <Portal>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: theme.zIndex.snackbar + 1,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Slide in={updateAvailable} direction="down" mountOnEnter unmountOnExit>
          <Box sx={{ width: '100%', pointerEvents: 'auto' }}>
            <Alert variant="filled" severity="info" sx={{ borderRadius: 0 }}>
              App updated — will refresh when you next switch away.{' '}
              <Box
                component="span"
                onClick={() => window.location.reload()}
                sx={{
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  fontWeight: 600,
                }}
              >
                Refresh now
              </Box>
            </Alert>
          </Box>
        </Slide>
      </Box>
    </Portal>
  );
}
